export default __webpack_public_path__ + "static/media/RFID-card.e8f339a4.svg";